import React, { useState, useEffect, useCallback } from "react";

const Initial = (props) => {
	const { next } = props;
	return (
		<div className="container px-5 pt-5 custom-modal">
			<div className="row">
				<h2>Retailers!</h2>
			</div>
			<div className="row">
				<h3 className="text-muted text-center my-5">
					Increase Sales and Your Exposure Through eksplode!'s EAC and
					VAC Programs.
				</h3>
			</div>
			<div className="row mt-3 justify-content-center">
				<button
					className="btn btn-solid"
					style={{ minWidth: "200px" }}
					onClick={next}>
					Next
				</button>
			</div>
		</div>
	);
};

export default Initial;
